import { SlideUpModal } from "src/components/SlideUpModal";
import { useDlaFormSubmit } from "src/hooks/useDlaFormSubmit";
import { useWebClientApi } from "src/api";

type DeleteAddressModalProps = {
  isOpen: boolean;
  address_id: string;
  closeHandler: () => void;
  deleteHandler: () => void;
};

export default ({
  isOpen,
  address_id,
  closeHandler,
  deleteHandler,
}: DeleteAddressModalProps) => {
  if (!isOpen) return null;

  const api = useWebClientApi();
  const [submitDelete, loading] = useDlaFormSubmit(
    async () => api.deleteAddress(address_id),
    { onSuccess: () => deleteHandler() },
  );
  return (
    <SlideUpModal
      title="Remove this address"
      isOpen={isOpen}
      closeHandler={closeHandler}
      hasDismissButton={true}
      actionButtonText="Remove"
      isLoading={loading}
      actionButtonClickHandler={() => void submitDelete({})}
    >
      This action cannot be undone.
    </SlideUpModal>
  );
};
